/**
 * The owner's stepped reveal (decision 53), the timings the wall and the owner's card share: the
 * drum roll before each podium place (by place: 1st, 2nd, 3rd), and how long the card's keys rest
 * after a press, so the next press never lands while the wall is still rolling.
 */

export const STEP_ROLL_MS: Record<number, number> = { 1: 5000, 2: 3000, 3: 2000 };

/** The place (1, 2 or 3) step `n` puts up, or null for an award or the empty podium. */
export function placeAt(n: number, of: number, places: number): number | null {
  if (n <= of || places < 1) return null;
  return places - (n - of) + 1;
}

/** How long the card rests after sending step `to` (null: taken off) from `from`. */
export function restMs(from: number, to: number | null, of: number, places: number): number {
  if (to === null || to < from) return 1500;
  const place = placeAt(to, of, places);
  return place === null ? 2500 : (STEP_ROLL_MS[place] ?? 2000) + 1000;
}
